import { Link, Outlet, useLoaderData, useLocation, useSearchParams} from "react-router-dom";
import ServerFooter from "src/components/common/ServerFooter";
import UserInfo from "src/components/common/UserInfo";
import { WorkOrder, assignmentText } from "./types";
export const extraFields = ["page", "limit", "orderBy"];
export default function WorkOrders(){
    const {workOrders, total} = useLoaderData<{workOrders: WorkOrder[], total: number}>() ?? [];
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const onFilter = [...searchParams.keys()].filter(param => !extraFields.includes(param)).length > 0;
    const orderBy = searchParams.get("orderBy") ?? "";
    const deadlineOrderSymbol = orderBy === "deadlineASC" ? "↑" : orderBy === "deadlineDESC" ? "↓" : "⇅";
    return(
        <div className = {"cssContent" + (total > 0?" pb8rem":"")}>
            <nav className = "mt-2">
                <Link
                    children = "Settings"
                    to = "Settings"
                    className = "btn btn-outline-success"
                />
                <Link className = {"btn btn-outline-primary ms-3 position-relative"} to = {{ pathname: "Filter", search: location.search }}>
                    Filter
                    {onFilter?<span children = "on" className = "badge text-bg-primary position-absolute top-0 start-100 translate-middle" style = {{minWidth: "2.4em"}}/>:null}
                </Link>
                <Link
                    children = "Export"
                    to = {{ pathname: "Export", search: location.search }}
                    className = "btn btn-outline-primary ms-3"
                />
                <Link
                    children = "Add"
                    to = "Add"
                    className = "btn btn-outline-primary float-end"
                />
                <input
                    id = "search"
                    className = "form-control inline ms-3"
                    type = "text"
                    placeholder = "Search By Lab Number"
                    defaultValue = {searchParams.get("labNumber") ?? ""}
                    onKeyDown = {(e) => {
                        if(e.key === "Enter"){
                            const params = new URLSearchParams(searchParams);
                            params.set("page", "1");
                            if((e.target as HTMLInputElement).value){
                                params.set("labNumber", (e.target as HTMLInputElement).value);
                            } else {
                                params.delete("labNumber");
                            }
                            setSearchParams(params, { replace: false });

                        }
                    }}
                />
                <button type = "button" className = "btn btn-outline-primary ms-2" onClick = {e => {
                    const params = new URLSearchParams(searchParams);
                    const inputElement = ((e.target as HTMLInputElement).previousSibling as HTMLInputElement);
                    params.set("page", "1");
                    if(inputElement.value){
                        params.set("labNumber", inputElement.value);
                    } else {
                        params.delete("labNumber");
                    }
                    setSearchParams(params, { replace: false });
                }}>Confirm</button>
            </nav>
            <form>
                <div className = "table-responsive">
                    <table className = "table">
                        <thead>
                            <tr className = "noBorderTop">
                                <th>Customer</th>
                                <th>Requestor</th>
                                <th>PO Number</th>
                                <th>Quote Number</th>
                                <th>Lab Number</th>
                                <th>
                                    <button
                                        children = "Deadline"
                                        type = "button"
                                        className = "noButtonStyle pointer"
                                        onClick = {() => {
                                            const params = new URLSearchParams(searchParams);
                                            switch(orderBy){
                                                case "deadlineASC":
                                                    params.set("orderBy", "deadlineDESC");
                                                    break;
                                                case "deadlineDESC":
                                                    params.delete("orderBy");
                                                    break;
                                                case "":
                                                    params.set("orderBy", "deadlineASC");
                                                    break;
                                                default:
                                                    break;
                                            }
                                            setSearchParams(params, { replace: false });
                                        }}
                                    />
                                    <strong className = "text-danger" children = {deadlineOrderSymbol}/>
                                </th>
                                <th>Techs</th>
                                <th>Work Order Status</th>
                                <th>Assigned</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {(total > 0 ? workOrders.map((workOrder, key) => 
                            <tr key = {key}>
                                <td>
                                    <Link children = {workOrder.organizationName} to = {`/Organizations/${workOrder.organizationId}`}/>
                                </td>
                                <td>
                                    <Link children = {workOrder.contactName} to = {`/Contacts/${workOrder.contactId}`}/>
                                </td>
                                <td>{workOrder.poNumber}</td>
                                <td>{workOrder.quoteNumber}</td>
                                <td>{workOrder.labNumber}</td>
                                <td>{workOrder.deadline}</td>
                                <td>{workOrder.techs?.map(tech => <li key = {tech.value}><UserInfo id = {tech.value} name = {tech.label}/></li>)}</td>
                                <td>{workOrder.workOrderStatus}</td>
                                <td>{assignmentText(workOrder.techs)}</td>
                                <th>
                                    <Link
                                        children = "Detail"
                                        to = {String(workOrder.id)}
                                        className = "btn btn-outline-primary"
                                    />
                                </th>
                            </tr>):
                            <tr><td className = "loading" style = {{backgroundColor:"white"}} colSpan = {100}>No Work Orders Yet</td></tr>)
                            }
                        </tbody>
                    </table>
                </div>
            </form> 
            {total ? <ServerFooter length = {total}/> : null}
            <Outlet/>
        </div>
    )
}
